import { CreateAddressRequest } from '@src/main/modules/messages/infrastructure/dto/createAddressRequest';
import { createAddressHttpRepository } from '@src/main/modules/messages/infrastructure/repository/AddressHttpRepository';
import { TokenProvider } from '@src/main/shared/infrastructure/entity/axios';

export const createAddressUseCase = async (
  data: CreateAddressRequest,
  tokenProvider: TokenProvider,
) => {
  const repository = createAddressHttpRepository(tokenProvider);
  return await repository.create(data);
};
